import { render, staticRenderFns } from "./GasStatistics.vue?vue&type=template&id=3c22cb21&scoped=true&"
import script from "./GasStatistics.vue?vue&type=script&lang=js&"
export * from "./GasStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GasStatistics.vue?vue&type=style&index=0&id=3c22cb21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22cb21",
  null
  
)

export default component.exports